const four={
	title: '`housing` - це зручно',
	img:[
		'bi/np.png',
		'bi/delivery.jpg',
		'bi/intime.png',
		'bi/urk.png',
	],
	text: 'Ми створили нашу Компанію та цей сайт, щоб Вам було зручно і легко в одному\
		місці вибрати все, що необхідно для пересадки рослин, оновлення домашнього\
		чи садового інтер’єру, або прикраси Вашої оселі. У відповідних розділах\
		основного меню Ви знайдете всю необхідну інформацію по всім видам продукції,\
		якими займається наша Компанія, з фотографіями, характеристиками товарів та\
		актуальними цінами. Одразу після отримання замовлення наші менеджери\
		зв’яжуться з Вами, аби обрати найбільш комфортний для Вас спосіб оплати та доставки.\
		Ми намагалися зробити процес вибору та купівлі товару якомога зручнішим для Вас і\
		сподіваємося, що наші зусилля не лишилися марними.'
};

export default four;